/**
 * Internal dependencies
 */
import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';

export default {
	reducer,
	actions,
	selectors,
};
